import { Pages } from '@models/Pages'

const NON_BROWSABLE_LOCATIONS = [
  '/',
  '/index.html',
  `/${Pages.About}`,
  `/${Pages.Methodology}`,
  `/${Pages.Partners}`,
  `/${Pages.Terms}`,
  `/${Pages.Privacy}`,
  `/${Pages.Contact}`,
]

export function isPathBrowsable(pathname: string): boolean {
  return !NON_BROWSABLE_LOCATIONS.find((p) => pathname.endsWith(p))
}
